import React, { useContext, useEffect, useState } from "react";
import { Menu, Icon, Spin, Avatar, notification } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { useRef } from "react";
import { withRouter } from "react-router-dom";
import { ContextAPI } from "../../../ContextAPI";
import telecmiIcon from "../../../assets/teleicon.png";
import user from "../../../assets/download.png";
import { Modal } from "antd";

import HeaderDropdown from "../HeaderDropdown";
import "./index.less";
import { getPiopiy, piopiyLogin, logoutPiopiy } from "../../../utils/piopiy";
import { platformApi } from "../../../api";
import { Dropdown } from "antd";
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import { ENDPOINT } from "../../../constants";
import { io } from "socket.io-client";

// Reuse one audio instance globally
const notificationAudio = new Audio(
  "https://autocloudstorage.sgp1.digitaloceanspaces.com/Production/Ring_Tone/1753941927074-callalert_notification.mp3"
);


const AvatarDropdown = (props) => {
  const userCred = useContext(ContextAPI);
  const { history } = props;
  const { loginCredintials } = useContext(ContextAPI);
  const token = localStorage.getItem("token");

  const [companyReadAccess, setCompanyReadAccess] = useState(false);
  const [companySettingsAccess, setCompanySettingsAccess] = useState(false);
  const [telecmiAccess, setTelecmiAccess] = useState(false);
  const [telecmiUsers, setTelecmiUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(
    () => localStorage.getItem("selectedTelecmiUserId") || null
  );
  const pollingRef = useRef(null);
  let lastNotificationTime = 0;
  const MIN_INTERVAL = 5000;
  const hasNotificationsAccess = () =>
    loginCredintials?.roleAccess &&
    loginCredintials.roleAccess.some(
      (each) =>
        String(each.subModule || "").toLowerCase() === "notifications" &&
        each.access?.read
    );

  const handleMissedCallNotification = (data) => {
    // Prefer per-user Notifications module (socket userNotification). Legacy
    // broadcast only shows popup if this user has Notifications read AND is recipient.
    if (!hasNotificationsAccess()) return;
    const recipientId = data?.data?.recipientUserId || data?.recipientUserId;
    const myId = loginCredintials?.employeeId || loginCredintials?.id;
    if (recipientId && myId && String(recipientId) !== String(myId)) return;
    const now = Date.now();
    if (now - lastNotificationTime > MIN_INTERVAL) {
      showMissedCallAlert(data);
      lastNotificationTime = now;
    }
  };

  const showMissedCallAlert = (notificationData) => {
    const alertData = {
      title: "Missed Call Alert",
      message: `Incoming call from ${
        notificationData.data?.customer?.name || notificationData.data?.from
      } was missed`,
    };

    // Play ringtone
    try {
      notificationAudio.currentTime = 0;
      notificationAudio.play().catch((error) => {
        console.error("Failed to play notification audio:", error);
      });
    } catch (err) {
      console.error("Audio play error:", err);
    }

    // Remove old popup if it exists
    const oldPopup = document.getElementById("missed-call-popup");
    if (oldPopup) oldPopup.remove();

    // Create new popup
    const popup = document.createElement("div");
    popup.id = "missed-call-popup";
    popup.style.cssText = `
      position: fixed;
      top: 70px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9999;
    `;
    popup.innerHTML = `
      <div style="
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 6px 20px rgba(0,0,0,0.2);
        padding: 20px 30px;
        font-weight: bold;
        text-align: center;
        width: 400px;
        animation: fadeIn 0.3s ease;
        position: relative;
      ">
        <!-- Close X button -->
        <span id="missed-call-close" style="
          position: absolute;
          top: 8px;
          right: 12px;
          cursor: pointer;
          font-size: 18px;
          font-weight: bold;
          color: #999;
        ">
          &times;
        </span>

        <div style="font-size: 18px; margin-bottom: 8px;">${alertData.title}</div>
        <div style="font-size: 16px;">${alertData.message}</div>
      </div>
    `;

    document.body.appendChild(popup);

    // Close handler (X button)
    document
      .getElementById("missed-call-close")
      .addEventListener("click", () => popup.remove());

    // Auto close after 5s
    setTimeout(() => {
      if (popup) popup.remove();
    }, 5000);
  };


  useEffect(() => {
    loginCredintials.roleAccess &&
      loginCredintials.roleAccess.map((each) => {
        if (each.subModule === "company") {
          if (each.access && each.access.read === true) {
            setCompanyReadAccess(true);
          }
        }
        if (each.subModule === "company_settings") {
          if (each.access && each.access.read === true) {
            setCompanySettingsAccess(true);
          }
        }
        if (each.subModule === "telecmi") {
          if (each.access && each.access.read === true) {
            setTelecmiAccess(true);
          }
        }
      });
  }, [loginCredintials]);

  useEffect(() => {
    if (!telecmiAccess) return;

    const socket = io(ENDPOINT, {
      transports: ["websocket"],
      auth: {
        token: token,
      },
    });

    socket.on("connect", () => {
      console.log("✅ Connected to TeleCMI socket");
    });

    socket.on("connect_error", (err) => {
      console.error("❌ Socket connection error:", err.message);
    });

    socket.on("teleUserStatus", (message) => {
      if (message && message.type === "teleUserStatus") {
        setTelecmiUsers(message.data);
      }
    });

    socket.on("missedCallNotification", (data) => {
      handleMissedCallNotification(data);
    });

    return () => {
      socket.disconnect();
    };
  }, [telecmiAccess, token]);

  useEffect(() => {
    getTelecmiUsers();
  }, []);

  // Notification Call auto-claim: sync header selected agent
  useEffect(() => {
    const onAgentSelected = (e) => {
      const agentId = e?.detail?.agentId;
      if (!agentId) return;
      setSelectedUserId(agentId);
      localStorage.setItem("selectedTelecmiUserId", agentId);
      getTelecmiUsers();
    };
    window.addEventListener("telecmi-agent-selected", onAgentSelected);
    return () =>
      window.removeEventListener("telecmi-agent-selected", onAgentSelected);
  }, []);

  const getTelecmiUsers = () => {
    platformApi.get("/api/telecmi/teleuser").then((res) => {
      setTelecmiUsers(res.data.data);
    });
  };

  useEffect(() => {
    if (
      !selectedUserId ||
      !telecmiUsers.length ||
      !loginCredintials.employeeName
    )
      return;

    const data = telecmiUsers.find((obj) => selectedUserId === obj.id);

    // Still syncing after auto-claim — status online but occupant name not yet set
    if (data?.status === true && !data.userName) {
      return;
    }

    // Offline seat, or claimed by a different employee
    if (
      !data?.status ||
      (data.status &&
        data.userName &&
        data.userName != loginCredintials.employeeName)
    ) {
      localStorage.removeItem("selectedTelecmiUserId");
      setSelectedUserId(null);
      logoutPiopiy();
    }
  }, [telecmiUsers, loginCredintials]);

  const toggleUserStatus = async (id) => {
    try {
      await platformApi.post(`/api/telecmi/teleUser/toggleStatus/${id}`);
      // await getTelecmiUsers();
    } catch (err) {
      console.error("Toggle user status error:", err);
    }
  };

  const handleSelectUser = async (user) => {
    if (user.status) {
      if (user.id === selectedUserId) {
        await toggleUserStatus(user.id);
        setSelectedUserId(null);
        localStorage.removeItem("selectedTelecmiUserId");
        logoutPiopiy();
      }
      return;
    }

    if (selectedUserId && selectedUserId !== user.id) {
      await toggleUserStatus(selectedUserId);
      logoutPiopiy();
    }

    await toggleUserStatus(user.id);
    setSelectedUserId(user.id);

    localStorage.setItem("selectedTelecmiUserId", user.id);

    // CRITICAL FIX: Proper async handling of piopiy login
    try {
      await piopiyLogin(null, user.teleCMIUserID);
    } catch (error) {
      console.error("Failed to login to piopiy:", error);
      // Revert user status if login fails
      await toggleUserStatus(user.id);
      setSelectedUserId(null);
      localStorage.removeItem("selectedTelecmiUserId");
    }
  };

  const selectedUser = telecmiUsers.find((u) => u.id === selectedUserId);

  // useEffect(() => {
  //   if(!telecmiAccess) return;

  //   const intervalId = setInterval(() => {
  //     getTelecmiUsers();
  //   }, 15000);

  //   return () => clearInterval(intervalId);
  // }, [telecmiAccess]);

  const teleUserMenu = (
    <Menu>
      {telecmiUsers.map((userObj) => {
        const isSelected = userObj.id === selectedUserId;
        return (
          <Menu.Item
            key={userObj.id}
            onClick={() => handleSelectUser(userObj)}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "8px",
              padding: "8px",
              backgroundColor: isSelected ? "#e6f7ff" : "transparent",
            }}
          >
            <div
              disabled={userObj.status && !isSelected}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor:
                  userObj.status && !isSelected ? "not-allowed" : "pointer",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <Avatar src={user} size="small" />
                <span>{userObj.teleCMIUserName}</span>
              </div>
              {/* Native title — Ant Tooltip inside Menu.Item reuses one overlay (wrong name on every row) */}
              <span
                title={
                  userObj.status
                    ? userObj.userName || "Busy"
                    : "Available"
                }
                style={{ display: "inline-flex", lineHeight: 1 }}
              >
                {userObj.status ? (
                  <CloseCircleTwoTone twoToneColor="#ff4d4f" />
                ) : (
                  <CheckCircleTwoTone twoToneColor="#52c41a" />
                )}
              </span>
            </div>
            {
              // userObj.status && userCred?.loginCredintials?.role == "CEO" && !isSelected &&
              userObj.status && !isSelected && (
                <span
                  title={`Logout ${userObj.userName || ""}`.trim()}
                  style={{ display: "inline-flex", lineHeight: 1 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleUserStatus(userObj.id);
                  }}
                >
                  <LogoutOutlined />
                </span>
              )
            }
          </Menu.Item>
        );
      })}
    </Menu>
  );

  const onMenuClick = async (event) => {
    const { key } = event;

    if (key === "logout") {
      try {
        if (selectedUserId) {
          await toggleUserStatus(selectedUserId);
        }

        localStorage.removeItem("branch");
        localStorage.removeItem("selectedTelecmiUserId");
        localStorage.removeItem("piopiyLoginState");
        localStorage.removeItem("token");

        await logoutPiopiy();

        setTimeout(() => {
          history.push("/login");
        }, 1000);
      } catch (error) {
        console.error("Logout error:", error);
        window.location.reload();
      }
    } else if (key === "companySettings") {
      history.push("/autoadmin/company");
    }
  };

  const {
    currentUser = {
      avatar: "",
      name: "",
      role: "",
    },
    menu,
  } = props;
  const menuHeaderDropdown = (
    <Menu className="menu" selectedKeys={[]} onClick={onMenuClick}>
      {menu && companySettingsAccess && (
        <Menu.Item key="companySettings">
          <Icon type="setting" theme="filled" />
          Company Settings
        </Menu.Item>
      )}
      {menu && <Menu.Divider />}
      <Menu.Item key="logout">
        <Icon type="logout" />
        Logout
      </Menu.Item>
    </Menu>
  );

  return currentUser && currentUser.name ? (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "16px",
        height: "100%",
      }}
    >
      {telecmiAccess && (
        <Dropdown overlay={teleUserMenu} trigger={["click"]}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              userSelect: "none",
            }}
          >
            {!selectedUser && (
              <img
                src={telecmiIcon}
                alt="TeleCMI Logo"
                style={{
                  height: "30px",
                  width: "30px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            )}
            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {selectedUser && (
                <span
                  style={{
                    height: "12px",
                    width: "12px",
                    borderRadius: "50%",
                    backgroundColor: selectedUser ? "#4CBB17" : "",
                  }}
                ></span>
              )}
              {selectedUser ? selectedUser.teleCMIUserName : "TeleCMI Users"}
            </span>

            {/* <span>{selectedUser ? selectedUser.teleCMIUserName : "TeleCMI Users"}</span> */}
          </div>
        </Dropdown>
      )}

      <HeaderDropdown overlay={menuHeaderDropdown}>
        <span className="action account">
          <Avatar
            size="small"
            className="avatar"
            src={currentUser.avatar}
            alt="avatar"
          />
          <span
            style={{
              display: "inline-block",
              verticalAlign: "middle",
            }}
          >
            <span
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <span className="role">{currentUser.name}</span>
              <span className="role" style={{ fontSize: "12px" }}>
                {currentUser.role}
              </span>
            </span>
          </span>
        </span>
      </HeaderDropdown>
    </div>
  ) : (
    <Spin
      size="small"
      style={{
        marginLeft: 8,
        marginRight: 8,
      }}
    />
  );
};

export default withRouter(AvatarDropdown);
